import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DocViewDto } from 'src/app/models/track/doc-view-dto';
import { DomSanitizer } from '@angular/platform-browser';
import { QuoteRenderingService } from 'src/app/services/search/quote-rendering.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-pdf-view',
  templateUrl: './pdf-view.component.html',
  styleUrls: ['./pdf-view.component.scss']
})
export class PdfViewComponent implements OnInit {

  content: DocViewDto;
  docDto: DocViewDto;
  image: any;
  dataLocalUrl: any;

  constructor( 
    public dialogRef: MatDialogRef<PdfViewComponent>,
    @Inject(MAT_DIALOG_DATA) data: DocViewDto,
    private sanitizer: DomSanitizer,private qoutationService: QuoteRenderingService) {
    dialogRef.disableClose = true;
    this.content = data; 
   }

  ngOnInit() {
    this.docDto=this.qoutationService.docViewDto;
    var file3 = new Blob([this.base64ToArrayBuffer(this.docDto.document)], {type: 'application/pdf'});
    this.dataLocalUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(file3)+"#toolbar=0");
  }

  close() {
    this.qoutationService.docViewDto=null;
    this.dialogRef.close(this.content);
  }

  base64ToArrayBuffer(base64: any) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes;
}

  

}
